import { useReturnsIntakeData, COMPLIANCE_MAP } from './useReturnsIntakeData';
import { useCloseReturnsIntake } from './useCloseReturnsIntake';
import { useMemo, useState } from 'react';

const TAB_INDEX_TO_KEY = ['returned', 'unexpected', 'nonReported'];

const useReturnsIntakeReport = () => {
  const { data, driverId, isLoading, isError, refetch, stats, mappedShippings } = useReturnsIntakeData();
  const { handleFinish, handleGoToStart, isClosing } = useCloseReturnsIntake(driverId);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  const filteredShippings = useMemo(() => {
    return mappedShippings.filter((item) => {
      const group = COMPLIANCE_MAP[item.complianceName];
      return group === TAB_INDEX_TO_KEY[activeTab];
    });
  }, [mappedShippings, activeTab]);

  return {
    shippings: filteredShippings,
    driverName: data?.driverName || '',
    driverId: driverId || '',
    status: data?.status || '',
    stats,
    isLoading: isLoading || isClosing,
    isError,
    activeTab,
    handleTabChange,
    handleGoToStart,
    handleFinish,
    refetch,
  };
};

export default useReturnsIntakeReport;
